// Initialize Sentry before anything else
import './instrument';

import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
// Geist (body font) is loaded via Google Fonts in index.html.
// Import Figtree font for headings and display
import '@fontsource-variable/figtree';
// Import Poppins font (still used by the Brand Space font picker)
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
// Import custom fonts
import './assets/fonts/fonts.css';
// Initialize i18n
import './libs/i18n';
import { metaPixel } from './libs/meta-pixel';

// Only loads on the marketing consent given on fluenceur.com.
metaPixel.boot();

// Create root with React 19 error hooks for better error handling
const root = ReactDOM.createRoot(document.getElementById('root')!, {
  // These hooks will catch errors that occur during rendering
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.error('Uncaught error:', error, errorInfo);
  }),
  onCaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Caught error:', error, errorInfo);
  }),
  onRecoverableError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Recoverable error:', error, errorInfo);
  }),
});

root.render(<App />);
